<div class="templates scrollable-container">
  <template-item
    *ngFor="let template of templates"
    [template]="template"
    (onTemplateClicked)="onTemplateClicked.emit($event)"
  ></template-item>
</div>
